import { useHasAnyFeature } from "@/hooks/useHasAnyFeature";

import { FeatureProps } from "./type";
import { Upsale } from "./upsale";

export const Feature = ({
  required,
  children,
  upsale,
  asChild,
  fallback = null,
}: FeatureProps) => {
  const features = Array.isArray(required) ? required : [required];
  const allow = useHasAnyFeature(...features);

  return allow ? (
    <>{children}</>
  ) : upsale ? (
    <Upsale asChild={asChild} required={required}>
      {children}
    </Upsale>
  ) : fallback ? (
    fallback
  ) : null;
};
